<ion-content class="ion-padding">
  <ion-refresher slot="fixed" (ionRefresh)="carregarCadastro($event)">
    <ion-refresher-content>
    </ion-refresher-content>
  </ion-refresher>

  <usucampeao-contrato-selecionar-forma-pagamento *ngIf="!!cadastro" [reurbGratuito]="projeto?.reurbGratuito"
    [possuiPagamento]="!projeto?.semPagamento" [possuiSuperSocial]="projeto?.possuiSuperSocial" [cadastro]="cadastro"
    [tabelaPreco]="tabelaPreco" (aoSelecionarFormaPagamento)="aoSelecionarFormaPagamento($event)"
    (aoCancelarProgramaSuperSocial)="cancelarProgramaSuperSocial()">
  </usucampeao-contrato-selecionar-forma-pagamento>
</ion-content>